<template>
    <div class="web_index">
        <div class="web_title">
            <div class="web_title_content">
                <img class="title_img" src="../../assets/png/nav_logo_title.png">
                <div class="title_content">
                    <div v-bind:class="[jumpType === 5 ? 'title_red' : 'title']" @click="jump(5)">
                        <span style="cursor:pointer;">联系我们</span>
                    </div>
                    <div v-bind:class="[jumpType === 4 ? 'title_red' : 'title']" style="margin-right: 50px"
                         @click="jump(4)">
                        <span style="cursor:pointer;">加入我们</span>
                    </div>
                    <div v-bind:class="[jumpType === 3 ? 'title_red' : 'title']" style="margin-right: 50px"
                         @click="jump(3)">
                        <span style="cursor:pointer;">商务合作</span>
                    </div>
                    <div v-bind:class="[jumpType === 2 ? 'title_red' : 'title']" style="margin-right: 50px"
                         @click="jump(2)">
                        <span style="cursor:pointer;">关于我们</span>
                    </div>
                    <div v-bind:class="[jumpType === 1 ? 'title_red' : 'title']" style="margin-right: 50px"
                         @click="jump(1)">
                        <span style="cursor:pointer;">首页</span>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%;height: 80px">
        </div>

        <div class="column_div">
            <div class="column">
                <div v-bind:class="[columnType === 1 ? 'column_name_red' : 'column_name']" @click="choose(1)">
                    <span style="cursor:pointer;">《看天下》杂志</span>
                </div>

                <div v-bind:class="[columnType === 2 ? 'column_name_red' : 'column_name']" @click="choose(2)">
                    <span style="cursor:pointer;">Vista看天下 APP</span>
                </div>

                <div v-bind:class="[columnType === 3 ? 'column_name_red' : 'column_name']" @click="choose(3)">
                    <span style="cursor:pointer;">Vista看天下微博</span>
                </div>

                <div v-bind:class="[columnType === 4 ? 'column_name_red' : 'column_name']"
                     @click="choose(4)">
                    <span style="cursor:pointer;"> Vista看天下微信公众号</span>
                </div>

                <div v-bind:class="[columnType === 5 ? 'column_name_red' : 'column_name']"
                     @click="choose(5)">
                    <span style="cursor:pointer;"> Vista看天下抖音</span>
                </div>

                <div v-bind:class="[columnType === 6 ? 'column_name_red' : 'column_name']"
                     @click="choose(6)">
                    <span style="cursor:pointer;"> 小风小浪微信公众号</span>
                </div>

                <div v-bind:class="[columnType === 7 ? 'column_name_red' : 'column_name']" @click="choose(7)">
                    <span style="cursor:pointer;">《锋绘》杂志</span>
                </div>

                <div v-bind:class="[columnType === 8 ? 'column_name_red' : 'column_name']" @click="choose(8)">
                    <span style="cursor:pointer;">故事飞船 APP</span>
                </div>

                <div v-bind:class="[columnType === 9 ? 'column_name_red' : 'column_name']" @click="choose(9)">
                    <span style="cursor:pointer;">原创IP 小怪兽乌拉拉</span>
                </div>

                <!--<div v-bind:class="[columnType === 10 ? 'column_name_red' : 'column_name']" @click="choose(10)">-->
                    <!--<span style="cursor:pointer;">天下Daily社群媒体</span>-->
                <!--</div>-->

                <div v-bind:class="[columnType === 10 ? 'column_name_red' : 'column_name']" @click="choose(10)">
                    <span style="cursor:pointer;">Vista氢商业</span>
                </div>

                <!--<div v-bind:class="[columnType === 12 ? 'column_name_red' : 'column_name']" @click="choose(12)">-->
                    <!--<span style="cursor:pointer;">原创IP 神马雷雷</span>-->
                <!--</div>-->
                <div v-bind:class="[columnType === 11 ? 'column_name_red' : 'column_name']" @click="choose(11)">
                    <span style="cursor:pointer;">动来屋</span>
                </div>
            </div>
        </div>

        <div class="web_content">
            <div class="content">
                <div id="one" style="height: 30px;background-color: #F0F4F5;" class="stip"></div>
                <div class="content_type" ref="scrollOne">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">《看天下》杂志</span>
                        <!--<span style="font-size: 16px;color: #323232">做最好的杂志</span>-->
                    </div>
                    <div class="content_two" style="margin-top: 10px">
                        <span>●宁夏日报报业集团主管主办，《看天下》杂志社出版</span>
                        <span style="padding-left: 40px;">●海丰传媒代理《看天下》杂志广告与发行业务</span>
                    </div>
                    <img class="content_img"  src="../../assets/png/banner_vista.jpg">
                    <div class="content_two">
                        《看天下》是中国新闻期刊市场上，为数不多的面向高端消费人群的新闻杂志，创造了中国媒体的“看天下模式”。
                    </div>
                    <div class="content_two">
                        我们立志做“中国最好看的新闻杂志”， 杂志的内容涵盖时政、财经、社会、科技、文化、时尚、娱乐等领域， 我们将过去 10 天发生在全球的精彩故事呈送给读者。

                    </div>
                    <div class="content_two">
                        《看天下》目前为旬刊， 版式风格和阅读节奏始终瞄准国际一流新闻杂志， 每月 8 日、18 日、28 日出版，全年 35 期。

                    </div>

                    <div class="content_two" style="text-align: left;">
                        <img src="../../assets/png/about_us_ktx_01.png" width="950">
                        <img src="../../assets/png/about_us_ktx_02.png" width="770">
                    </div>

                    <div class="content_erweima">
                        <div class="content_erweima_title" style="line-height: 80px;">
                            扫描订阅《看天下》杂志：
                        </div>
                        <img class="content_erweima_png" src="../../assets/png/erweima.png"
                             style="width:80px;height: 80px ">
                    </div>
                    <div class="content_three">
                        购买渠道：
                        <br/>
                        全国各报刊亭；邮局订阅；京东、天猫等第三方线上书店。
                    </div>
                    <div id="two" style="height: 30px;background-color: #F0F4F5;" class="stip"></div>
                </div>

                <div class="content_type" ref="scrollTwo">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">Vista看天下 APP</span>
                        <span style="font-size: 16px;color: #323232">给新闻加点意思</span>
                    </div>
                    <img class="content_img" src="../../assets/png/Vista_APP.png">
                    <div class="content_one">
                        《号外》理念：
                        和读者一起重新认识这个世界，打开世界少为人知的一面。
                    </div>
                    <div class="content_two">
                        依托国内发行量最大的新闻杂志之一——《看天下》，由编辑部原班人马打造的精品杂志客户端。
                        Vista看天下App不但承继了《看天下》杂志对新闻的追求，以及做最好看新闻杂志的愿景，
                        还更进一步贴近年轻读者，以更有趣的方式，深入解读社会热点事件、潮流与趋势，方便用户随时随地看天下。
                    </div>
                    <div class="content_two">
                        目前，Vista看天下App除了拥有《看天下》的全部电子刊内容，还打造了线上杂志类新产品《号外》，以更独特的视角、更具知识性的内容，
                        带领读者换一个姿势“看天下”， 早期《号外》封面有：《脑洞2019》、《糖！你好毒》、“重新认识美国系列”等。
                        下一阶段还将持续上线更多精彩内容。
                    </div>
                    <div class="content_two" style="margin-bottom: 200px">
                        App精选频道，每天更新由杂志编辑精心挑选的内容。
                    </div>
                    <div class="content_erweima">
                        <div class="content_erweima_title" style="width: 380px">
                            下载渠道：<br/>
                            1、iOS：苹果应用商店搜索“Vista看天下”，<a style="text-decoration: underline"
                                                        href="http://open3.vistastory.com/download.html">点击下载</a>；<br/>
                            2、安卓：各应用商店搜索“Vista看天下”，<a style="text-decoration: underline"
                                                      href="http://open3.vistastory.com/download.html">点击下载</a>。<br/>
                            3、扫码下载“Vista看天下”App
                        </div>
                        <img class="content_erweima_png" src="../../assets/png/erweima2.png"
                             style="width:80px;height: 80px ">
                    </div>
                    <div class="stip" id="three" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>


                <div class="content_type" ref="scrollThree">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">Vista看天下 官方微博</span>
                    </div>
                    <img class="content_img" src="../../assets/png/Vista_weibo.png">
                    <div class="content_two" style="line-height: 30px;padding-bottom: 50px;">
                        一个有趣的蓝V<br/>
                        紧跟新闻热点，但不盲目跟风<br/>
                        开通时间：2009年11月<br/>
                        粉丝数量：2560万+（数据统计时间2022年10月）
                        <!--排行情况：新榜机构号排名34（2019年7月9日榜单）-->
                    </div>
                    <!--<div class="content_two" style="margin-bottom: 150px;text-align: center;">-->

                        <!--&lt;!&ndash;<img src="../../assets/png/about_weibo_01.png" height="346" width="553"/>&ndash;&gt;-->

                        <!--<br/>-->
                        <!--&lt;!&ndash;影响力：全国新闻类微博账号100强前部账号&ndash;&gt;-->
                    <!--</div>-->
                    <div class="content_erweima">
                        <div class="content_erweima_title" style="line-height: 80px;width: 300px">
                            新浪微博@Vista看天下，或扫描以下二维码：
                        </div>
                        <img class="content_erweima_png" src="../../assets/png/erweima3.png"
                             style="width:80px;height: 80px ">
                    </div>
                    <div class="stip" id="four" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>


                <div class="content_type" ref="scrollFour">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">Vista看天下微信公众号</span>
                    </div>
                    <img class="content_img" src="../../assets/png/Vista_xiaochengxu.png">
                    <div class="content_two" style="line-height: 30px">
                        “一个更懂年轻人生活的公众号”<br/>
                        微信公众号开通时间：2012年9月<br/>
                        粉丝数量：300万+（数据统计时间：2022年10月）<br/>

                    </div>
                    <div class="content_two" style="margin-bottom: 200px">

                        头部账号，中国最懂年轻人的微信公众号之一。
                    </div>
                    <div class="content_erweima">
                        <div class="content_erweima_title" style="line-height: 80px;width: 450px">
                            “Vista看天下”微信公众号:微信搜索vistaweek，或扫描以下二维码：
                        </div>
                        <img class="content_erweima_png" src="../../assets/png/erweima4.png"
                             style="width:80px;height: 80px ">
                    </div>
                    <div class="stip" id="five" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>


                <div class="content_type" ref="scrollFour">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">Vista看天下抖音</span>
                    </div>
                    <img class="content_img" src="../../assets/png/banner_douyin.png">
                    <div class="content_two" style="line-height: 30px;margin-bottom: 50px;">
                        抖音粉丝数量：1975万+，累计获赞数17.5亿（数据统计时间：2022年 10月）；日点赞评论转发200万+，每日上抖音榜单数20条+ <br/>

                    </div>

                    <!--<div class="content_erweima">-->
                        <!--<div class="content_erweima_title" style="line-height: 80px;width: 450px">-->
                            <!--“Vista看天下”微信公众号:微信搜索vistaweek，或扫描以下二维码：-->
                        <!--</div>-->
                        <!--<img class="content_erweima_png" src="../../assets/png/erweima4.png"-->
                             <!--style="width:80px;height: 80px ">-->
                    <!--</div>-->
                    <div class="stip" id="c11" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>

                <div class="content_type" ref="scrollFour">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">小风小浪微信公众号</span>
                    </div>
                    <img class="content_img" src="../../assets/png/banner_fenglang.png">
                    <div class="content_two" style="line-height: 30px;margin-bottom: 50px;">

                        Vista 旗下文娱团队创办，成熟女性视角专栏
                        娱乐圈第二，陪伴女性成长第一
                        资深娱乐记者对行业的独到洞见
                        （数据统计时间：2022年10月）

                    </div>

                    <!--<div class="content_erweima">-->
                    <!--<div class="content_erweima_title" style="line-height: 80px;width: 450px">-->
                    <!--“Vista看天下”微信公众号:微信搜索vistaweek，或扫描以下二维码：-->
                    <!--</div>-->
                    <!--<img class="content_erweima_png" src="../../assets/png/erweima4.png"-->
                    <!--style="width:80px;height: 80px ">-->
                    <!--</div>-->
                    <div class="stip" id="c12" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>

                <div class="content_type" ref="scrollFive">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">《锋绘》杂志</span>
                    </div>
                    <img class="content_img" src="../../assets/png/banner_fenghui.png">
                    <div class="content_one">
                        阅读童年，锋绘相伴！<br/>
                        《锋绘》是一儿童绘本杂志，适合3~6岁儿童阅读。<br/>
                        《锋绘》致力于儿童阅读启蒙，提供高品质、多元化的绘本故事，在故事中开阔眼界，得到爱与美的滋养，点亮家庭亲子阅读时光。

                    </div>
                    <div class="content_two">
                        《锋绘》杂志于2016年6月创刊，是一本高品质的儿童绘本杂志，是国内最接近绘本图书品质的幼儿杂志之一。版权合作方Histoires pour les petits，隶属于法国排名第一、在整个欧洲也名列前茅的专业儿童期刊出版集团Bayard，汇集欧洲一流童书作家、一流插画师的最新创作，畅销20余年，全球读者超过100万。
                       <br/> 原创故事签约多位获奖名家，故事品质一流：语言美、画面美，传递独立、平等、自由、博爱的精神。
                        <br/> 独家原创小怪兽乌拉拉科普系列连载，故事性、知识性、趣味性兼备，在故事中感受探索与发现的乐趣。邀请权威专家审核，知识科学严谨。
                        <br/> 这本杂志内容丰富，故事类型几乎涵盖儿童阅读领域的所有类型，提供科普启蒙、经典故事、创意思维、童话故事、 情感教育、习惯培养、性格养成、传统文化等多种类别且风格不同的绘本故事，满足早期阅读的全面需要。
                        <br/>杂志采用157g亚光铜版纸、环保大豆油墨印刷，精细呈现图画品质，贴心守护儿童安全。

                    </div>

                    <div class="content_two" style="margin-bottom: 100px">
                        主要内容：<br/>
                        ❄每期3个精品绘本故事，风格各异，涵盖不同的成长领域。
                        <br/>❄独家原创小怪兽乌拉拉科普系列连载，适合3~6岁小朋友的科普绘本故事。
                        <br/>❄走近非遗栏目、传统文化绘本故事，丰富孩子的人文视野，提升民族自信。
                        <br/>❄全年69个绘本故事，类型丰富，总有孩子喜欢的那一款。
                    </div>
                    <div class="stip" id="six" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>

                <div class="content_type" ref="scrollSix">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">故事飞船 APP</span>
                    </div>
                    <img class="content_img" src="../../assets/png/Gsfc_APP.png">
                    <div class="content_one">
                        故事飞船APP是一款线上的儿童阅读产品，专门针对2-6岁儿童阅读教育而研发，由绘本杂志《锋绘》与线上精品阅读课程等内容相结合，
                        涉及丰富的儿童阅读品类，如科普启蒙、习惯培养、性格养成、传统文化、经典故事、幽默故事、创意思维、情感教育等，
                        让小朋友在快乐阅读的同时，更高效地提升他们的阅读能力。
                    </div>
                    <div class="content_two">
                        内容结构：<br/>
                        三大优质IP为孩子的阅读提供充足养分：<br/>
                        科普启蒙IP小怪兽乌拉拉系列：为孩子提供有趣生动的科普故事，享受有趣故事的同时，学习科普启蒙知识，从而让孩子爱上科学。<br/>
                        习惯培养及性格养成类IP完美小孩系列：温和的行为养成故事，用不说教的方式，帮助孩子养成良好的生活习惯，培养适应力强的完美小孩。<br/>
                        中国经典神话IP西游记系列：专为6岁以下儿童改编的《西游记》，经典的故事配上中国优秀的插画原创团队，让孩子学龄前就爱上中国传统名著。
                    </div>
                    <div class="content_two">
                        产品功能：<br/>
                        线上『宝宝会读』52周阅读计划，系统提升宝宝阅读能力<br/>
                        飞船阅读课，让孩子一边阅读一边学知识<br/>
                        互动故事，让故事动起来，激发孩子阅读兴趣，提升孩子对故事的理解<br/>
                        故事音频，央广电台知名主播为孩子讲故事
                    </div>
                    <div class="content_two" style="margin-bottom: 150px">
                        内容设计：<br/>
                        与法国知名的儿童出版社Bayard版权合作<br/>
                        中国优秀的原创故事平台<br/>
                        线上课程、阅读计划由资深幼儿教育团队全程参与整编<br/>
                        每个故事由国内外专业童书编辑团队精心制作挑选<br/>
                        符合儿童心理、生理发展需要，每个故事都深受孩子喜爱<br/>
                         大咖专家讲座，让亲子阅读变得更美好更简单
                    </div>
                    <div class="content_erweima">
                        <div class="content_erweima_title" style="width: 250px;line-height: 80px;">
                            扫描二维码，下载“故事飞船”APP：
                        </div>
                        <img class="content_erweima_png" src="../../assets/png/erweima5.png"
                             style="width:80px;height: 80px ">
                    </div>
                    <div class="stip" id="seven" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>

                <div class="content_type" ref="scrollSeven">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">原创IP 小怪兽乌拉拉</span>
                    </div>
                    <img class="content_img" src="../../assets/png/banner_wulala.png">
                    <div class="content_two">
                        小怪兽乌拉拉<br/>
                        来自米尔星的外星小怪兽，拥有独特的外形特征：头上长角，三只眼睛，三条腿，鼻子上有条纹……
                        他个性活泼，调皮可爱，想象力丰富，好奇心极强，喜欢自己动脑筋解决问题。
                    </div>
                    <div class="content_two">
                        蓝莫和艾莉<br/>
                        小怪兽乌拉拉的爸爸和妈妈，他们和小怪兽乌拉拉一起乘坐奶酪飞船来到地球。
                    </div>
                    <div class="content_two" style="margin-bottom: 100px">
                        奶酪飞船<br/>
                        小怪兽乌拉拉的座驾，同时也是他的玩伴。奶酪飞船能变身不同的交通工具：
                        奶酪潜艇、奶酪汽车……它还有网络检索、穿越时空、瞬间转移、变化大小等超能力。
                        这些神奇的功能帮助小怪兽乌拉拉在地球上完成各种奇妙的探险之旅。
                    </div>
                    <div class="stip" id="eight" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>

                <!--<div class="content_type" ref="scrollEight">-->
                    <!--<div class="content_title">-->
                        <!--<span style="font-size: 24px;color: #000000">天下DAILY社群媒体</span>-->
                    <!--</div>-->
                    <!--<img class="content_img" src="../../assets/png/banner_DAILY.png">-->
                    <!--<div class="content_two">-->
                        <!--产品简介：<br/>-->
                        <!--天下Daily，是专业媒体团队出品的新锐社群新闻媒体，旨在为微信读者群的用户精选有趣有料的优质热门新闻，-->
                        <!--内容涵盖时政、财经、文娱等多个领域。-->
                    <!--</div>-->
                    <!--<div class="content_two">-->
                        <!--发行方式：<br/>-->
                        <!--天下Daily主要依托于微信读者群发行，添加官方微信（微信号：Vistaya01）即可申请进群阅读新闻。-->
                    <!--</div>-->
                    <!--<div class="content_two">-->
                        <!--出版周期：<br/>-->
                        <!--在微信群内，每个工作日09:00、13:00、17:00在微信群内推送；节假日早10:00准时推送。-->
                    <!--</div>-->
                    <!--<div class="content_two">-->
                        <!--用户群体：<br/>-->
                        <!--目前已累积15万+订阅用户。主要用户群为拥有良好教育背景、关注国内外热点新闻、乐于接受新鲜观念、年龄在25岁左右的都市潮流青年。-->
                    <!--</div>-->
                    <!--<div class="content_two">-->
                        <!--主要内容：<br/>-->
                        <!--年轻人感兴趣的时政社会热点的延展解读；新潮有趣的环球奇闻逸事；公众人物的秘闻绯闻；关于新商业趋势与商业人物的趣味报道；-->
                        <!--热门影视综艺与话题明星的观察追踪；年轻人新潮的生活方式和有趣的人类观察报告等。-->
                    <!--</div>-->
                    <!--<div class="content_two" style="margin-bottom: 150px">-->
                        <!--联系我们：<br/>-->
                        <!--官方微信号：天下DAILY（VistaNews）-->
                    <!--</div>-->
                    <!--<div class="content_erweima">-->
                        <!--<div class="content_erweima_title" style="width: 250px;line-height: 80px;">-->
                            <!--扫码加入天下读者会：-->
                        <!--</div>-->
                        <!--<img class="content_erweima_png" src="../../assets/png/erweima6.png"-->
                             <!--style="width:80px;height: 80px ">-->
                    <!--</div>-->
                    <!--<div class="stip" id="nine" style="height: 30px;background-color: #F0F4F5;"></div>-->
                <!--</div>-->

                <div class="content_type" ref="scrollNine">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">Vista氢商业</span>
                    </div>
                    <img class="content_img" src="../../assets/png/banner_qsy.png">
                    <div class="content_two" style="margin-bottom: 100px;">
                        国内头部女性消费与商业新媒体<br/>
                        新女性 新消费 轻商业<br/>
                        陪伴1亿新女性共同成长<br/>
                        易懂有趣，为新女性量身定制的商业内容 <br/>
                        聚焦女性喜爱的时尚美丽、生活消费、新文化领域<br/>
                        报道女性高频高价消费的品牌和产品，洞悉用户消费心理 <br/>
                        图文+流媒体+社群，多种形态立体化覆盖<br/>
                        <!--微信：60 万 <br/>-->
                        <!--社群：700个，覆盖15万人<br/>-->
                        <!--抖音：10万 <br/>-->
                        全网粉丝100万+（数据统计时间：2022年10月）<br/>

                    </div>
                    <!--<div class="content_two">-->
                        <!--主要用户：<br/>-->
                        <!--20-25岁、对商业感兴趣、充满好奇的年轻城市人群-->
                    <!--</div>-->
                    <!--<div class="content_two">-->
                        <!--主要内容：<br/>-->
                        <!--知名公司、财经大佬的热门新闻；知名公司的争议性事件；互联网/新商业的近况观察；影视综艺背后的公司报道-->
                    <!--</div>-->
                    <!--<div class="content_two" style="margin-bottom: 200px">-->
                        <!--联系我们：<br/>-->
                        <!--微信号“Vista氢商业”（vistabusiness）-->
                    <!--</div>-->
                    <div class="content_erweima">
                        <div class="content_erweima_title" style="width: 250px;line-height: 120px;text-align: right;">
                            扫描关注《Vista氢商业》
                        </div>
                        <img class="content_erweima_png" src="../../assets/png/qr_qsy.png"
                             style="width:120px;height: 120px ">
                    </div>
                    <div class="stip" id="ten" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>


                <div class="content_type" ref="scrollDlw">
                    <div class="content_title">
                        <span style="font-size: 24px;color: #000000">动来屋</span>
                    </div>
                    <img class="content_img" src="../../assets/png/dlw_banner.png">
                    <div class="content_two">
                        动来屋是一个带领孩子体验真实且童趣的<span style="text-decoration: underline">线上野生动物之旅的神奇动物园</span>，不断更新包含野生动物科普知识的卡牌以及生动有趣的闯关内容。<br/>

                    </div>

                    <div class="content_two">
                        我们面向3-7岁儿童，让孩子感受趣味性的同时收获知识。线上动物园有动物学专家全程做知识和场景的梳理和产出，保证内容和知识的真实性。闯关场景真实还原野生动物所在的自然环境，给孩子一个高仿真的体验氛围。<br/>

                    </div>
                    <div class="content_two">
                        动来屋将野生动物知识点与热门卡牌玩法融合，构建线性化且有趣味性的成长任务，让孩子在闯关的过程中收集知识卡牌，学习科普知识，帮助动物伙伴解决困难，一起探索大自然。借助线上产品的视觉和交互优势，给孩子带来更多维、更多感官刺激的沉浸式学习体验。<br/>

                    </div>
                    <div class="content_two">
                        我们的目标是构建少儿动物科普卡牌文化，让更多的孩子有机会体验在虚拟世界动物园中探索的乐趣，将见到的和学到的科普知识化作一张张精美的卡牌，陪伴孩子成长。<br/>

                    </div>

                    <div class="content_two" style="margin-bottom: 250px;">
                        动来屋，玩出动物科普。

                    </div>
                    <!--<div class="content_two">-->
                    <!--主要用户：<br/>-->
                    <!--20-25岁、对商业感兴趣、充满好奇的年轻城市人群-->
                    <!--</div>-->
                    <!--<div class="content_two">-->
                    <!--主要内容：<br/>-->
                    <!--知名公司、财经大佬的热门新闻；知名公司的争议性事件；互联网/新商业的近况观察；影视综艺背后的公司报道-->
                    <!--</div>-->
                    <!--<div class="content_two" style="margin-bottom: 200px">-->
                    <!--联系我们：<br/>-->
                    <!--微信号“Vista氢商业”（vistabusiness）-->
                    <!--</div>-->
                    <!--<div class="content_erweima">-->
                        <!--<div class="content_erweima_title" style="width: 250px;line-height: 120px;text-align: right;">-->
                            <!--扫描关注《Vista氢商业》-->
                        <!--</div>-->
                        <!--<img class="content_erweima_png" src="../../assets/png/qr_qsy.png"-->
                             <!--style="width:120px;height: 120px ">-->
                    <!--</div>-->
                    <div class="stip" id="dlw" style="height: 30px;background-color: #F0F4F5;"></div>
                </div>

                <!--<div class="content_type" ref="scrollTen">-->
                    <!--<div class="content_title">-->
                        <!--<span style="font-size: 24px;color: #000000">原创IP 神马雷雷</span>-->
                    <!--</div>-->
                    <!--<img class="content_img" src="../../assets/png/banner_smll.png">-->
                    <!--<div class="content_two" style="margin-bottom: 500px">-->
                        <!--产品情况简介：<br/>-->
                        <!--讲述年轻人职场生活与生活的搞笑漫画，以四格漫画+长条漫的方式逐步打造最直击年轻人灵魂的漫画产品。-->
                    <!--</div>-->
                    <!--<div style="height: 30px;background-color: #F0F4F5;"></div>-->
                <!--</div>-->
            </div>

        </div>


        <component v-bind:is="'BaseBottom'"></component>
    </div>
</template>

<script>
    import BaseBottom from './BaseBottom.vue'
    import router from '../../router'

    export default {
        components: {BaseBottom: BaseBottom},
        name: 'Index',
        data() {
            return {
                jumpType: 1,
                columnType: 1,
                navShow: ''
            }
        },
        methods: {
            jump(type) {
                let that = this
                // that.jumpType = type
                if (type == 1) {
                    router.push({
                        path: '/',
                        // query:{'jumpType':type}
                    })
                } else if (type == 2) {
                    router.push({
                        path: 'area',
                        // query:{'jumpType':type}
                    })
                } else if (type == 3) {
                    router.push({
                        path: 'cooperate',
                        // query:{'jumpType':type}
                    })
                } else if (type == 4) {
                    router.push({
                        path: 'join',
                        // query:{'jumpType':type}
                    })
                } else if (type == 5) {
                    router.push({
                        path: 'contact',
                        // query:{'jumpType':type}
                    })
                }
            },
            choose(type) {
                let that = this
                that.columnType = type
                // alert(that.columnType)
                const returnEles=document.querySelectorAll('.stip')
                const returnEle=returnEles[type-1]
                if (!!returnEle) {
                    returnEle.scrollIntoView(true);
                }

//                if (type == 1) {
//                    const returnEle = document.querySelector("#one");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 2) {
//                    const returnEle = document.querySelector("#two");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 3) {
//                    const returnEle = document.querySelector("#three");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 4) {
//                    const returnEle = document.querySelector("#four");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 5) {
//                    const returnEle = document.querySelector("#five");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 6) {
//                    const returnEle = document.querySelector("#six");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 7) {
//                    const returnEle = document.querySelector("#seven");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 8) {
//                    const returnEle = document.querySelector("#eight");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 9) {
//                    const returnEle = document.querySelector("#nine");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                } else if (type == 10) {
//                    const returnEle = document.querySelector("#ten");
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                }else{
//                    const returnEle = document.querySelector("#c"+type);
//                    if (!!returnEle) {
//                        returnEle.scrollIntoView(true);
//                    }
//                }
            },

            handleScroll() {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // alert(scrollTop)

                this.navShow = scrollTop;

                const contentList=document.querySelectorAll('.content_type')

                let allHeight=0;
                console.log(scrollTop+'<'+contentList[0].offsetHeight);
                if(scrollTop<contentList[0].offsetHeight){
                    this.columnType = 1;
                    return;
                }

                for(var i=0;i<contentList.length;i++){

                    let currentHeight=contentList[i].offsetHeight;
                    allHeight=allHeight+currentHeight;
                    if(scrollTop<allHeight){
                        break;
                    }
                    this.columnType = i+2;
                }
                console.log(this.columnType,'<<'+allHeight)

//                let oneHeight = this.$refs.scrollOne.offsetHeight;
//                let twoHeight = this.$refs.scrollTwo.offsetHeight + oneHeight;
//                let threeHeight = this.$refs.scrollThree.offsetHeight + twoHeight;
//                let fourHeight = this.$refs.scrollFour.offsetHeight + threeHeight;
//                let fiveHeight = this.$refs.scrollFive.offsetHeight + fourHeight;
//                let sixHeight = this.$refs.scrollSix.offsetHeight + fiveHeight;
//                let sevenHeight = this.$refs.scrollSeven.offsetHeight + sixHeight;
//                let eightHeight = this.$refs.scrollEight.offsetHeight + sevenHeight;
//                let nineHeight = this.$refs.scrollNine.offsetHeight + eightHeight;
//                let tenHeight = this.$refs.scrollTen.offsetHeight + nineHeight;
//                for(var i=11;i<=12;i++){
//
//                }
//
//                console.log(oneHeight + "-" + twoHeight + "-" + threeHeight + "-" + fourHeight + "-" + fiveHeight + "-" + sixHeight + "-" + sevenHeight + "-" + eightHeight + "-" + nineHeight + "-" + tenHeight);
//                if (scrollTop < oneHeight) {
//                    this.columnType = 1;
//                }
//                if (scrollTop > oneHeight) {
//                    this.columnType = 2;
//                }
//                if (scrollTop > twoHeight) {
//                    this.columnType = 3;
//                }
//                if (scrollTop > threeHeight) {
//                    this.columnType = 4;
//                }
//                if (scrollTop > fourHeight) {
//                    this.columnType = 5;
//                }
//                if (scrollTop > fiveHeight) {
//                    this.columnType = 6;
//                }
//                if (scrollTop > sixHeight) {
//                    this.columnType = 7;
//                }
//                if (scrollTop > sevenHeight) {
//                    this.columnType = 8;
//                }
//                if (scrollTop > eightHeight) {
//                    this.columnType = 9;
//                }
//                if (scrollTop > nineHeight) {
//                    this.columnType = 10;
//                }

            }

        },
        mounted() {
            // alert(this.$route.query.columnType)
            if (this.$route.query.columnType != null) {
                this.columnType = this.$route.query.columnType
                this.choose(this.columnType)
            }
            window.addEventListener("scroll", this.handleScroll);

        },
        updated() {
            window.addEventListener("scroll", this.handleScroll);
        }
    }
</script>


<style scoped="page">
    .web_index {
        width: 100%;
        background-color: #F0F4F5;
    }

    .web_title {
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        position: fixed;
        top: 0;
        z-index: 1000;
    }

    .web_title_content {
        width: 1290px;
        height: 80px;
        margin: auto;
        position: relative;
    }

    .title_img {
        margin-left: 40px;
        margin-top: 18px;
    }

    .title_content {
        height: 80px;
        position: absolute;
        right: 45px;
        top: 0;
    }

    .title {
        float: right;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
    }

    .title_red {
        float: right;
        height: 70px;
        line-height: 80px;
        font-size: 18px;
        border-bottom: 2px solid #cd001b;
        color: #000000;
    }

    .column_div {
        width: 1210px;
        height: 540px;
        position: fixed;
        top: 110px;
        left: calc(50% - 605px);
    }

    .column {
        width: 180px;
        /*height: 540px;*/
        background-color: #535353;
    }

    .web_content {
        width: 1210px;
        margin: auto;
    }

    a {
        text-decoration: none
    }

    .column_name {
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
    }

    .column_name_red {
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        background-color: #EE534B;
    }

    .content_title {
        margin-left: 30px;
        padding-top: 60px;
    }

    .content_img {
        margin-left: 30px;
        margin-top: 40px;
    }

    .content {
        width: 1010px;
        background-color: #ffffff;
        margin-left: 200px;
    }

    .content_type {
        /*margin-top: 20px;*/
        position: relative;

    }

    /*.content_one {*/
        /*margin-left: 30px;*/
        /*margin-right: 30px;*/
        /*margin-top: 40px;*/
        /*font-size: 16px;*/
        /*color: #323232;*/
    /*}*/

    .content_one,.content_two {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 30px;
        font-size: 14px;
        color: #323232;
        line-height: 22px !important;
    }

    .content_two img{max-width: 950px;}

    .content_three {
        margin-left: 30px;
        margin-top: 60px;
        margin-bottom: 60px;
        font-size: 14px;
        color: #323232;
    }

    .content_erweima {
        position: absolute;
        right: 30px;
        bottom: 48px;
    }

    .content_erweima_title {
        float: left;
        font-size: 14px;
        color: #323232;
        width: 210px;
    }

    .content_erweima_png {
        float: left;
    }


    .web_bottem {
        background-color: #2E3139;
        width: 100%;
        height: 120px;
        font-size: 16px;
        color: #C4C4C4;
        line-height: 120px;
        text-align: center;
    }


</style>



// WEBPACK FOOTER //
// src/components/web/AboutUs.vue